export default __webpack_public_path__ + "static/media/arrow-left.21115365.svg";